import Vue from 'vue'

export const {
  alertOrderStatusView,
  warningOrderStatusView,
  noticeOrderStatusView,
} = (() => {
  interface ColorCode {
    'background-color'?: string
    'color'?: string
    'font-weight'?: string
  }
  const baseView = (name: string, colorCode: ColorCode = {}) => Vue.extend({
    name,
    template: `<component :is="tag" :style="style"><slot></slot></component>`,
    data: () => ({
      style: colorCode,
    }),
    props: {
      tag: {
        type: String,
        default: 'div',
      },
    },
  })

  return {
    alertOrderStatusView: baseView('AlertOrderStatusView', { 'background-color': '#FDEFEF', color: '#DC5353', 'font-weight': '700' }),
    warningOrderStatusView: baseView('WarningOrderStatusView', { 'background-color': '#F9F1E3', color: '#F4B030', 'font-weight': '700' }),
    noticeOrderStatusView: baseView('NoticeOrderStatusView', { 'font-weight': '700' }),
  }
})()
